import {
    RENTAL_PAYMENT_METHOD_CREDIT_CARD,
    RENTAL_PAYMENT_METHOD_LINE_PAY,
    RENTAL_PAYMENT_METHOD_APPLE_PAY,
} from 'constants/rental';
import PropTypes from 'prop-types';
import { I18n } from "react-redux-i18n";

export default function PaymentMethod({ status }) {
    const labels = {
        [RENTAL_PAYMENT_METHOD_CREDIT_CARD]: I18n.t('credit_card_no'),
        [RENTAL_PAYMENT_METHOD_LINE_PAY]: 'LINE Pay',
        [RENTAL_PAYMENT_METHOD_APPLE_PAY]: 'Apple Pay'
    };

    switch (status) {
    case RENTAL_PAYMENT_METHOD_CREDIT_CARD:
        return labels[RENTAL_PAYMENT_METHOD_CREDIT_CARD];
    case RENTAL_PAYMENT_METHOD_LINE_PAY:
        return labels[RENTAL_PAYMENT_METHOD_LINE_PAY];
    case RENTAL_PAYMENT_METHOD_APPLE_PAY:
        return labels[RENTAL_PAYMENT_METHOD_APPLE_PAY];
    default:
        return 'N/A';
    }
}

PaymentMethod.propTypes = {
    status: PropTypes.number.isRequired
};
